'use client';
import Description from '@/components/Description';
import { Button, ProgressBar } from '@yaradigitallabs/ahua-react';
import type React from 'react';
import type { ProductionLine } from '../../utils/types';
import { formatDate } from '@/utils/helpers';
import { MINUTES_IN_A_DAY } from '../../utils/constants';
import { convertMinutesToHours } from '../../utils/helpers';

type AddProductionReportListHeaderProps = {
  openProductionPeriod: () => void;
  selectedDate: string;
  facility?: ProductionLine | null;
  isLoading?: boolean;
  completedSteps?: number;
};

const AddProductionReportListHeader: React.FC<
  AddProductionReportListHeaderProps
> = ({
  openProductionPeriod,
  selectedDate,
  facility,
  isLoading,
  completedSteps,
}) => {
  return (
    <div className="px-8 py-3 bg-white rounded-md flex flex-col justify-between items-center lg:flex-row">
      <div className="flex justify-between lg:justify-start items-center gap-8 flex-1 lg:flex-none w-full lg:w-auto mb-4 lg:mb-0">
        <Description
          description={formatDate(selectedDate, {
            separator: '/',
            withoutTime: true,
          })}
          boldDescription
          title="Date"
          isLoading={isLoading}
        />
        <Description
          description={
            facility
              ? `${facility.facility_code} - ${facility.facility_description}`
              : '-'
          }
          boldDescription
          title="Production line"
          isLoading={isLoading}
        />
      </div>
      <div className="flex justify-between lg:justify-end items-center gap-8 flex-1 lg:flex-none w-full lg:w-auto">
        <ProgressBar
          numberOfSteps={MINUTES_IN_A_DAY}
          completedSteps={parseInt(completedSteps?.toString() || '0')}
          className="min-w-[16rem]"
          startLabel="0h/24h of production"
          labels={
            Array.from(
              { length: parseInt(completedSteps?.toString() || '0') },
              () =>
                `${convertMinutesToHours(completedSteps ? completedSteps : 0)}/24h of production`
            ) || []
          }
        />
        <Button
          colorConcept="brand"
          iconLeading="Plus"
          size="xs"
          variant="primary"
          className="flex-1"
          onClick={openProductionPeriod}
        >
          Add new period
        </Button>
      </div>
    </div>
  );
};

export default AddProductionReportListHeader;
